import { Button, Search, Size } from '@usitsdasdesign/dds-react';
import Text from 'atoms/Text';
import Drawer from 'molecules/Drawer';
import AlertModal from 'molecules/AlertModal';
import { useState } from 'react';
import Image from 'molecules/Image';

function LoginOnBehalf({
    onClose,
    valueChanged,
    searchResults = [],
    onLogin = () => { },
    showAlert,
    setShowAlert = () => { }
}) {
    const [data, setData] = useState({});

    const clickOnLogin = (row) => {
        setShowAlert(true);
        setData(row)
    }

    const clickOnSave = () => {
        onLogin(data)
        setShowAlert(false);
    }

    return (
        <Drawer
            show={true}
            title="Login on behalf"
            isFooter={false}
            onClose={onClose}
            headerMargin=''
        >
            <Text variant='label' className='mb-1' color='text-gray-1100'>Choose a resource</Text>
            <Search
                icon="search__s__stroke"
                placeholder="Search for a resource"
                size="l"
                valueChanged={valueChanged}
            />
            {
                searchResults.map((row, i) => (
                    <div className='p-2 border border-grey-600 mb-1 mt-1 flex gap-2 items-center relative' key={i}>
                        <Image
                            src={row.userpic}
                            height={62}
                            width={62}
                            alt='user'
                            showInitial
                            name={row.name}
                        />
                        <div className='flex flex-1 flex-col gap-1'>                        
                            <Text variant='bodySemibold' color="text-black">{row.name}&nbsp;</Text>
                            <Text variant='labelSemibold' color="text-gray-1100">{row.empID}  {row.email && `| ${row.email}`}</Text>
                            <Text variant='label' color="text-gray-1100"> {row.designation && `${row.designation} |`} {row.category && `${row.category} |`} {row.Subcategory} {row.SubSubcategory && ` | ${row.SubSubcategory}`} </Text>
                        </div>
                        <Button
                            label='Login'
                            size={Size.s}
                            className='button-custom-text'
                            onClick={() => clickOnLogin(row)}
                        />
                    </div>
                ))
            }
            {
                showAlert && <AlertModal
                    show={showAlert}
                    title={"Login on behalf"}
                    description={`Are you sure you want to login on behalf of ${data?.name}`}
                    onSave={() => clickOnSave()}
                    onClose={() => setShowAlert(false)}
                    saveLabel='Yes'
                    cancelLabel='No'
                />
            }
        </Drawer>
    )
}

export default LoginOnBehalf;